import { render, staticRenderFns } from "./PotSetupDetail.vue?vue&type=template&id=043079e1&"
import script from "./PotSetupDetail.vue?vue&type=script&lang=js&"
export * from "./PotSetupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports